/**
 * @fileoverview DELETE handler for the "/alloys/:provider/agentic/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysProviderAgenticAppGroupIdCacheKeys } from "./constants";
import type {
  DeleteAlloysProviderAgenticAppGroupIdProps,
  DeleteAlloysProviderAgenticAppGroupIdResult,
} from "./types";

export const deleteAlloysProviderAgenticAppGroupId = reactQueryMutationAdapter(
  deleteAlloysProviderAgenticAppGroupIdCacheKeys,
  (props: DeleteAlloysProviderAgenticAppGroupIdProps): Promise<DeleteAlloysProviderAgenticAppGroupIdResult> => {
    return fetch(`/alloys/${props.provider}/agentic/${props.appGroupId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
